<template>
  <div class="home">
    <div class="c-carousel">
      <agile
        :nav-buttons="false"
        :dots="false"
        :autoplay-speed="5000"
        :speed="2500"
        :pauseOnHover="false"
        fade
        autoplay
      >
        <div
          v-for="image in images"
          :key="image"
          class="c-carousel__slide"
          :style="{
            backgroundImage: `url(https://contest2018.s3.amazonaws.com/homepage/${image}.jpg)`
          }"
        ></div>
      </agile>
      <div class="c-carousel__logo">
        <img :src="`/img/logo_${$i18n.locale}.png`" alt="" />
      </div>

      <go-to-button anchor="#main-content"></go-to-button>
    </div>

    <div id="main-content" class="container" v-view.once="viewHandler">
      <div class="row justify-content-sm-center">
        <div class="col-md-12 col-lg-10">
          <section class="block text-center">
            <h6
              class="intro fnt font-default-light"
              v-html="$t('HOMEPAGE__INTRO')"
            ></h6>
          </section>

          <section class="text-center">
            <ul class="steps">
              <li>
                <router-link :to="{ name: 'register' }">
                  <slide-x-left-transition :delay="700">
                    <img v-show="showIcons" src="/img/destination.png" alt="" />
                  </slide-x-left-transition>
                  <h6
                    class="step-title fnt font-deco"
                    v-html="$t('HOMEPAGE__CHOOSE_DESTINATION')"
                  ></h6>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'register' }">
                  <slide-x-right-transition :delay="900">
                    <img v-show="showIcons" src="/img/avion.png" alt="" />
                  </slide-x-right-transition>
                  <h6
                    class="step-title fnt font-deco"
                    v-html="$t('HOMEPAGE__FILL_PLANE')"
                  ></h6>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'share' }">
                  <slide-x-left-transition :delay="1000">
                    <img v-show="showIcons" src="/img/share.png" alt="" />
                  </slide-x-left-transition>
                  <h6
                    class="step-title fnt font-deco"
                    v-html="$t('HOMEPAGE__SHARE')"
                  ></h6>
                </router-link>
              </li>
            </ul>
          </section>

          <div class="block p-t-b">
            <div class="text-center">
              <el-button type="primary" @click="gotoRegisterPage" class="fnt"
                >{{ $t("HOMEPAGE__START") }}<i class="fas fa-plane"></i
              ></el-button>
            </div>
          </div>

          <previous-winner-section>
            <template v-slot:cta>
              <el-button type="primary" @click="gotoRegisterPage" class="fnt"
                >{{ $t("HOMEPAGE__START") }}<i class="fas fa-plane"></i
              ></el-button>
            </template>
          </previous-winner-section>

          <div class="block p-b m-b text-center">
            <small class="footnote" v-html="$t('HOMEPAGE__FOOTNOTE')"></small>
          </div>
        </div>
      </div>
    </div>

    <access-link-form></access-link-form>
  </div>
</template>

<script>
import { VueAgile } from "vue-agile"

import AccessLinkForm from "../components/Form/AccessLinkForm"
import PreviousWinnerSection from "../components/Layout/PreviousWinnerSection"
import GoToButton from "../components/UI/GoToBtn"
import { getViewport } from "../helpers/viewport"

export default {
  name: "Home",
  components: {
    Agile: VueAgile,
    AccessLinkForm,
    PreviousWinnerSection,
    GoToButton
  },
  data() {
    return {
      images: ["100_italy2", "100_italy", "100_greece"],
      imageSize: null,
      showIcons: false
    }
  },
  methods: {
    gotoRegisterPage() {
      this.$router.push({ name: "register" })
    },
    viewHandler(e) {
      if (e.type === "enter") {
        this.showIcons = true
      }
    }
  },
  created() {
    const viewport = getViewport()

    switch (viewport) {
      case "xs":
        this.imageSize = 60
        break
      case "sm":
        this.imageSize = 60
        break
      case "md":
        this.imageSize = 60
        break
      case "lg":
        this.imageSize = 80
        break
      case "xl":
        this.imageSize = 80
        break
      default:
        this.imageSize = 100
    }
  }
}
</script>
